<form (ngSubmit)="onClickExport()">
  <div class="row">
    <div class="col-md-4">
      <div class="mt-2">
        <label>{{ "_General_Export_File_Type_Text_" | translate }}</label>
        <select
          class="cc-select-dropdown form-control"
          [(ngModel)]="fileTypeSelected"
          name="file-type-select"
        >
          <option
            *ngFor="let fileObject of selectableEntities"
            [ngValue]="fileObject.provisioningTypeId"
          >
            {{ fileObject.name }}
          </option>
        </select>
      </div>
    </div>
    <div class="col-md-4">
      <div class="ms-md-4 mb-2 mt-md-4">
        <button class="btn btn-primary mt-md-1" type="submit">
          {{ "_General_Data_Export_Text_" | translate }}
        </button>
      </div>
    </div>
  </div>
</form>
